// Mirrors floor.tables / floor.reservations / floor.table_sessions in
// CliqSuite_DB_Architecture.dc.html.
import { z } from "zod";

export const tableSchema = z.object({
  id: z.string().uuid(),
  store_id: z.string().uuid(),
  table_number: z.number().int(),
  label: z.string().nullable(),
  seats: z.number().int().default(2),
  qr_token: z.string().nullable(),
  is_active: z.boolean().default(true),
  sort_order: z.number().int().default(0),
  created_at: z.string(),
  updated_at: z.string(),
});
export type Table = z.infer<typeof tableSchema>;

export const reservationSchema = z.object({
  id: z.string().uuid(),
  store_id: z.string().uuid(),
  table_id: z.string().uuid().nullable(),
  guest_name: z.string(),
  party_size: z.number().int().default(2),
  reserved_for: z.string(),
  notes: z.string().nullable(),
  status: z.enum(["confirmed", "seated", "cancelled", "no_show"]).default("confirmed"),
  created_by_staff_id: z.string().uuid().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});
export type Reservation = z.infer<typeof reservationSchema>;

// A dine-in seating: the real "guest requested the bill" signal
// (bill_requested_at/bill_acknowledged_at) that Guest Portal and POS
// previously stubbed with a `[BILL REQUESTED]` marker in orders.notes.
export const tableSessionSchema = z.object({
  id: z.string().uuid(),
  table_id: z.string().uuid(),
  store_id: z.string().uuid(),
  order_id: z.string().uuid().nullable(),
  server_staff_id: z.string().uuid().nullable(),
  party_size: z.number().int().nullable(),
  status: z.enum(["open", "bill_requested", "closed"]).default("open"),
  bill_requested_at: z.string().nullable(),
  bill_acknowledged_at: z.string().nullable(),
  // Guest Portal's "Call Staff" button — cleared (set back to null) once
  // staff acknowledges it from the table drawer (see PosApp.tsx/
  // TablesScreen.tsx), same lifecycle as bill_requested_at but its own
  // independent flag rather than another `status` value, since a guest can
  // call staff at any point regardless of whatever the bill status is.
  staff_called_at: z.string().nullable(),
  seated_at: z.string(),
  closed_at: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});
export type TableSession = z.infer<typeof tableSessionSchema>;
